export function discountPercent(oldPrice, newPrice) {
	if (!oldPrice || oldPrice <= 0 || typeof newPrice !== 'number') {
		return 0
	}

	const percent = ((oldPrice - newPrice) / oldPrice) * 100

	if (percent <= 0) {
		return 0
	}

	return Math.round(percent)
}

/**
 * @param {number} price
 * @param {number} discountPercent float [1-100]
 * @returns {number}
 */
export function applyDiscount(price, discountPercent) {
	const value = (price / 100) * (100 - discountPercent)

	return Math.floor(value * 100) / 100
}
